import React from "react";
import styles from "./submit-request-success-step.module.scss";
import CommonDialog from "../../../../../common/components/dialog/CommonDialog";
import Button from "../../../../../common/ekedc-components/button/Button";

interface SubmitRequestSuccessStepProps {
	onBackToHome: () => void;
}

const TITLE = "Request Submitted";
const SUBTITLE = "Your service request has been submitted successfully. We'll keep you updated every step of the way.";

const SubmitRequestSuccessStep: React.FC<SubmitRequestSuccessStepProps> = ({ onBackToHome }) => {
	return (
		<CommonDialog onCloseDialog={onBackToHome} noPadding>
			<div className={styles.content}>
				<img
					className={styles.checkmark}
					src={`${process.env.PUBLIC_URL ?? ""}/gifs/checkmark.gif`}
					alt="Success"
				/>
				<h2 className={styles.title}>{TITLE}</h2>
				<p className={styles.subtitle}>{SUBTITLE}</p>
				<div className={styles.buttonWrap}>
					<Button text="Back to Home" onClick={onBackToHome} />
				</div>
			</div>
		</CommonDialog>
	);
};

export default SubmitRequestSuccessStep;
